define('viewmodels/tournaments/TournamentDetailsCardDialog',['underscore', 'knockout'], function (_, ko) {

    function TournamentDetailsCardDialog(dialog, campaignTitle, tournament) {
        var self = this;

        self.campaignTitle = campaignTitle;
        self.tournament = ko.observable(tournament);

        self.show = function() {
            dialog.showDialog(this);
        };

        self.close = function() {
            dialog.close(this);
        };

    };

    return TournamentDetailsCardDialog;
});

